<template>
  <b-container id="activate-users" style="margin-bottom: 40px">
    <b-spinner v-show="!isLoaded" label="Loading..." />
    <h1 v-if="users.length === 0 && isLoaded">Keine Benutzer gefunden</h1>
    <b-list-group>
      <b-list-group-item
        :to="'/users/' + user.usrId"
        v-for="user in users"
        :key="user.usrId"
        :variant="Number(user.usrIsActivated) ? 'success' : 'warning'"
        class="text-left text-md-center"
      >
        {{ user.usrFirstName }} {{ user.usrLastName }}
      </b-list-group-item>
    </b-list-group>
  </b-container>
</template>

<script>
export default {
  name: "ActivateUsers",
  data() {
    return {
      isLoaded: false,
      users: []
    };
  },
  mounted() {
    this.$http
      .get("/user")
      .then(response => (this.users = response.data.data))
      .finally(() => (this.isLoaded = true));
  }
};
</script>

<style scoped></style>
